export const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  .map((d, i) => ({
    index: i,
    fullName: d,
    shortName: d.slice(0, 3),
  }));
